module.exports = __webpack_public_path__ + "img/station spatiale.2ee6679c.png";